import type { CustomIconType } from "./types";
function SubWorkflowIcon({ size, color = "#ffffff" }: CustomIconType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width={size}
      height={size}
      enableBackground="new 0 0 442 442"
      version="1.1"
      viewBox="0 0 442 442"
      xmlSpace="preserve"
      fill={color}
    >
      <path d="M166.604 135.904h108.791c5.522 0 10-4.477 10-10V63.819c0-5.523-4.478-10-10-10H166.604c-5.522 0-10 4.477-10 10v62.085c0 5.523 4.478 10 10 10zm10-62.085h88.791v42.085h-88.791V73.819zM275.396 306.096H166.604c-5.522 0-10 4.477-10 10v62.085c0 5.523 4.478 10 10 10h108.791c5.522 0 10-4.477 10-10v-62.085c.001-5.523-4.477-10-9.999-10zm-10 62.085h-88.791v-42.085h88.791v42.085zM432 306.096H323.209c-5.522 0-10 4.477-10 10v62.085c0 5.523 4.478 10 10 10H432c5.522 0 10-4.477 10-10v-62.085c0-5.523-4.478-10-10-10zm-10 62.085h-88.791v-42.085H422v42.085zM118.791 306.096H10c-5.522 0-10 4.477-10 10v62.085c0 5.523 4.478 10 10 10h108.791c5.522 0 10-4.477 10-10v-62.085c0-5.523-4.478-10-10-10zm-10 62.085H20v-42.085h88.791v42.085zM211 250.5v35.596c0 5.523 4.478 10 10 10s10-4.477 10-10V250.5c0-5.523-4.478-10-10-10s-10 4.477-10 10z"></path>
      <path d="M64.396 296.096c5.522 0 10-4.477 10-10V231h293.209v55.096c0 5.523 4.478 10 10 10s10-4.477 10-10V221c0-5.523-4.478-10-10-10H231v-55.096c0-5.523-4.478-10-10-10s-10 4.477-10 10V211H64.396c-5.522 0-10 4.477-10 10v65.096c0 5.523 4.477 10 10 10z"></path>
    </svg>
  );
}

export default SubWorkflowIcon;
